import { WorkingHours } from 'store/workingHours/workingHours';
import { millisecondsInSecond } from 'helpers/timeConsts';
import { ScheduleWorkingHours } from './interfaces';

export default function convertToScheduleWorkingHours(
  workingHours: WorkingHours[],
): ScheduleWorkingHours[] {
  return workingHours.map((workingHour) => {
    const { date, seconds, project, projectPhase, id, employee, description } =
      workingHour;

    const startDate = new Date(date);
    const endDate = new Date(
      startDate.getTime() + seconds * millisecondsInSecond,
    );

    if (endDate.getDay() !== startDate.getDay()) {
      endDate.setTime(endDate.getTime() - 1);
    }

    return {
      startDate,
      endDate,
      seconds,
      project,
      projectPhase,
      id,
      employee,
      description,
    };
  });
}
